import {
  mapCompanyContactType,
  mapVenueOverviewVersionType,
  PermissionNameUnionType,
  useFindAllVenueFBContactsSuspense,
  useFindVenueOverviewVersionSuspense,
} from '@api';
import {
  EditActionIcon,
  TouringCard,
  TouringCardActions,
  TouringCardHeader,
  TouringCardSection,
  TouringCardTitle,
} from '@common';
import { usePermissionContext } from '@hypeit-gmbh/hypeit-ui-core';
import { Modal } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { useTranslation } from 'react-i18next';
import { Route } from 'src/routes/_rootLayout/venues/$id.overview.$version';
import {
  VenueFoodBeverageContactForm,
  VenueFoodBeverageContactTable,
} from './components';

export const VenueFoodBeverageContact: React.FC = () => {
  const { t } = useTranslation('venueDetailsOverview');
  const [opened, { open: openModal, close: closeModal }] = useDisclosure(false);
  const { id, version } = Route.useParams();

  const { data: overviewVersion } = useFindVenueOverviewVersionSuspense(
    id,
    version,
    {
      query: {
        select: (data) => mapVenueOverviewVersionType(data.data),
      },
    }
  );
  const { data: contacts } = useFindAllVenueFBContactsSuspense(id, {
    query: {
      select: (data) => data.data.map(mapCompanyContactType),
    },
  });
  const { hasPermission } = usePermissionContext<PermissionNameUnionType>();

  const userCanEditVenueFoodBeverageContact = hasPermission({
    permission: 'VENUES_OVERVIEW',
    action: 'WRITE',
  });

  return (
    <>
      <TouringCard data-testid="venue-food-beverage-contact">
        <TouringCardHeader>
          <TouringCardTitle>
            {t('VENUE_FOOD_BEVERAGE_CONTACT.TITLE')}
          </TouringCardTitle>
          <TouringCardActions>
            {userCanEditVenueFoodBeverageContact && (
              <EditActionIcon onClick={openModal} />
            )}
          </TouringCardActions>
        </TouringCardHeader>
        <TouringCardSection>
          <VenueFoodBeverageContactTable
            venueFoodBeverageContact={overviewVersion.foodBeverageContact}
          />
        </TouringCardSection>
      </TouringCard>
      <Modal
        opened={opened}
        onClose={closeModal}
        title={t('VENUE_FOOD_BEVERAGE_CONTACT.EDIT_MODAL_TITLE')}
      >
        <VenueFoodBeverageContactForm
          venueId={id}
          overviewVersion={version}
          venueFoodBeverageContact={overviewVersion.foodBeverageContact}
          onClose={closeModal}
          contacts={contacts}
        />
      </Modal>
    </>
  );
};
